import InitVueApp from '@/entry';
import { appElement } from '../config';
import App from './App';
import '@/plugins/v-click-outside';

new InitVueApp(App, appElement);
